'use strict';

exports.__esModule = true;
exports.MediaStream = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('material-ui/styles');

var _Grid = require('material-ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _DoneAll = require('material-ui-icons/DoneAll');

var _DoneAll2 = _interopRequireDefault(_DoneAll);

var _Clear = require('material-ui-icons/Clear');

var _Clear2 = _interopRequireDefault(_Clear);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  video: {
    border: "1px solid #ddd",
    width: "100%",
    maxWidth: "100%" // height: 300,

  },
  ok: {
    color: "green"
  },
  errors: {
    color: "red"
  }
};
var MediaStream = exports.MediaStream = (_temp = _class = function (_Component) {
  _inherits(MediaStream, _Component);

  function MediaStream() {
    _classCallCheck(this, MediaStream);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  MediaStream.prototype.render = function render() {
    if (typeof window === "undefined") {
      return null;
    }

    var _props = this.props,
        classes = _props.classes,
        stream = _props.stream,
        muted = _props.muted,
        other = _objectWithoutProperties(_props, ['classes', 'stream', 'muted']);

    if (!stream) {
      return null;
    } // return "Stream";


    var active = stream.active;
    var audioTrack = stream.getAudioTracks()[0];
    var videoTrack = stream.getVideoTracks()[0];
    var player = void 0;
    var mainStyle = {
      position: "relative",
      left: 0,
      bottom: 0,
      maxWidth: "100%"
    };

    if (active) {
      // const src = window.URL.createObjectURL(stream);
      if (videoTrack && videoTrack.enabled) {
        var _videoTrack$getSettin = videoTrack.getSettings(),
            aspectRatio = _videoTrack$getSettin.aspectRatio,
            width = _videoTrack$getSettin.width,
            heigth = _videoTrack$getSettin.heigth;

        player = _react2.default.createElement('video', _extends({
          className: classes.video // src={src}
          ,
          ref: function ref(element) {
            if (element) {
              element.srcObject = stream;
            }
          },
          autoPlay: true,
          playsInline: true,
          muted: muted,
          style: _extends({
            maxWidth: width,
            minHeight: 100,
            minWidth: 60
          }, mainStyle)
        }, other));
      } else if (audioTrack && audioTrack.enabled) {
        player = _react2.default.createElement('audio', _extends({
          // src={src}
          ref: function ref(element) {
            if (element) {
              element.srcObject = stream;
            }
          },
          autoPlay: true,
          playsInline: true,
          controls: true,
          muted: muted,
          style: _extends({}, mainStyle)
        }, other));
      }
    }

    return player || null;
  };

  return MediaStream;
}(_react.Component), _class.defaultProps = {
  muted: false
}, _temp);
MediaStream.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes2.default.object.isRequired,
  stream: _propTypes2.default.object.isRequired,
  muted: _propTypes2.default.bool.isRequired
} : {};
exports.default = (0, _styles.withStyles)(styles)(function (props) {
  return _react2.default.createElement(MediaStream, props);
});